<template>
  <q-item clickable @click="goToResult">
    <q-item-section>
      <q-item-label>{{ title }}</q-item-label>
      <q-item-label caption lines="2">{{ caption }}</q-item-label>
    </q-item-section>
    <q-item-section side>
      <q-icon name="search" color="primary" />
    </q-item-section>
  </q-item>
</template>

<script>
import { QIcon, QItem, QItemSection, QItemLabel } from 'quasar'

export default {
  name: 'OpenDataListItem',
  props: ['result'],
  components: {
    QIcon,
    QItem,
    QItemSection,
    QItemLabel
  },
  computed: {
    caption () {
      return this.result.notes
    },
    title () {
      return this.result.title
    }
  },
  methods: {
    goToResult () {
      this.$router.push({ name: 'opendataresult', params: { q: this.result.id } })
    }
  }
}
</script>
